class MicroCart extends HTMLElement {
      constructor() {
        super()
      }
    }

    customElements.define('micro-cart', MicroCart);

    class MicroCartListToggleButton extends HTMLElement {
      constructor() {
        super()
        this.addEventListener('click', (evt) => {
          evt.preventDefault()
          const microCartWrapper = document.getElementById('micro-cart__wrapper')
          microCartWrapper.classList.toggle('micro-cart__wrapper-collapsed')
        })
      }
    }

    customElements.define('micro-cart-list-toggle-button', MicroCartListToggleButton);

    class BMSMModalRemoveButton extends HTMLElement {
      constructor() {
        super()
        this.addEventListener('click', (evt) => {
          evt.preventDefault()
          this.removeFromCart()
        })
      }

    removeFromCart(){

      let formData = new FormData(this.form);
      const vid = this.getAttribute('data-variant-id')

      let updates = {
        [vid]: 0
      }

      // add loading states
      document.querySelector('.micro-cart__items.micro-cart__items-collapsed').classList.add('micro-cart__updating')
      document.querySelector('.micro-cart__checkout-btn-wrapper').classList.add('micro-cart__updating')

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
        })
        .then(async (response) => {
          if(response.ok) {
            reRenderAnnouncementBarAndMicroCartAndCartCount()
          }

          
          const bmsmModal = document.querySelector('bmsm-modal.active')
          if (bmsmModal) {
            const currentForm = document.querySelector('.form.in')
            if (currentForm) {
              const productId = currentForm.getAttribute('data-product-id')
              bmsmModal.refresh(productId)
            }
          }

          // remove loading states
          document.querySelector('.micro-cart__items.micro-cart__items-collapsed').classList.remove('.micro-cart__updating')
          document.querySelector('.micro-cart__checkout-btn-wrapper').classList.remove('.micro-cart__updating')
          return response.json()
        })
        .catch((error) => {
          console.error('Error:', error)
        })
      }
    }

    customElements.define('bmsm-modal-remove-button', BMSMModalRemoveButton)

    class MicroCartCheckoutButton extends HTMLElement {
      constructor() {
        super()
        this.addEventListener('click', (evt) => {
          evt.preventDefault()
          document.dispatchEvent(new Event('cartaddsuccess'));
          
           //document.dispatchEvent(new CustomEvent("theme:cart:toggle", { bubbles: true }));
           console.log('Here.....');
          // document.dispatchEvent(new CustomEvent("theme:cart:update", { bubbles: true })); 

          const cartItemsContainer = document.querySelector('cart-items');

          // Start refresh code Here....

          $('[data-section-type="cart-drawer"]').load(location.href + " #cart-drawer", function(response, status, xhr) {
              //console.log(response);
              if (status === "success") {
                  console.log("Cart drawer loaded successfully.");

                 
                setTimeout(function() {
                  document.dispatchEvent(new CustomEvent("theme:cart:toggle", { bubbles: true }));
                }, 500);

                // Additional code to execute after load is complete can go here
              } else {
                  console.error("Error loading cart drawer: " + xhr.status + " " + xhr.statusText);
              }
          });

          // fetch('/?section_id=cart-drawer', {
          //   method: 'GET',
          //   headers: {
          //     'Accept': 'text/html'
          //   }
          // })
          // .then(response => {
          //   if (!response.ok) {
          //     throw new Error('Network response was not ok');
          //   }
          //   return response.text();
          // })
          // .then(cartHtml => {
          //   // Parse the response HTML
          //   const parser = new DOMParser();
          //   const doc = parser.parseFromString(cartHtml, 'text/html');
          
          //   // Select the elements from the fetched HTML
          //   const newCartCount = doc.querySelector('cart-count').innerHTML;
           
          //   const newDrawerMessage = doc.querySelector('.drawer__message')?.innerHTML; // Adjust selector if needed
          //   const newCartItems = doc.querySelector('cart-items').innerHTML;
          //   const newCartTotal = doc.querySelector('#cartForm')?.innerHTML;
            
          //  // Update the elements in the current document
          //   if (newCartCount > 0) {
          //   // Select the element
          //   const cartDrawer = document.querySelector('#cart-drawer');
        
          //   // Remove the 'is-empty' class if it exists
          //   if (cartDrawer) {
          //       cartDrawer.classList.remove('is-empty');
          //   }
          //   } 
          
          //   // Update the elements in the current document
          //   if (newCartCount) {
          //     console.log(newCartCount)
          //     document.querySelector('.cart__items-count').innerHTML = newCartCount;
          //   }
            
           
            
          //   if (newDrawerMessage) {
          //     console.log(newDrawerMessage)
          //     document.querySelector('.drawer__message').innerHTML = newDrawerMessage; // Adjust selector if needed
          //   }

          //   if(newCartItems){
          //     document.querySelector('cart-items').innerHTML = newCartItems;
          //   }
            
            
          //   if (newCartTotal) {
          //     document.querySelector('#cartForm').innerHTML = newCartTotal;
          //   }
           
          
          // })
          // .catch(error => {
          //   console.error('Error fetching cart drawer content:', error);
          // });


// fetch(theme.routes.cart_url + '?section_id=api-cart-items')
//   .then(response => response.text())
//   .then(htmlString => {
//     // Parse the returned HTML
//     const parser = new DOMParser();
//     const parsedDocument = parser.parseFromString(htmlString, 'text/html');
    
//     // Extract the new cart items HTML
//     const newCartItemsHTML = parsedDocument.querySelector('[data-api-line-items]').innerHTML;

//     // Update the cart items in the DOM
//     if (cartItemsContainer) {
//       cartItemsContainer.innerHTML = newCartItemsHTML;
//     } else {
//       console.error('Cart items container not found in the DOM');
//     }

//     // If you need to do any post-update processing, do it here
//     // For example, reinitializing event listeners or updating totals
//     updateCartTotals();
//     reinitializeCartEventListeners();

//     console.log('Cart items updated successfully');
//   })
//   .catch(error => {
//     console.error('Error updating cart items:', error);
//   });

// // Example function to update cart totals (implement as needed)
// function updateCartTotals() {
//   // Implementation depends on your specific needs
//   console.log('Updating cart totals');
// }

// // Example function to reinitialize event listeners (implement as needed)
// function reinitializeCartEventListeners() {
//   // Implementation depends on your specific needs
//   console.log('Reinitializing cart event listeners');
// }

          // End refresh code Here....
           
          
        })
      }
    }

    customElements.define('micro-cart-checkout-button', MicroCartCheckoutButton)

    async function reRenderAnnouncementBarAndMicroCartAndCartCount() {
      // console.log('reRenderAnnouncementBarAndMicroCartAndCartCount - micro-cart')

      const response = await fetch(
        `${Shopify.routes}?sections=pack-builder-micro-cart`
      );
      const html = await response.json();

      // function extractCustomElementHTML(sectionHTML, customTag) {
      //   const openingTag = sectionHTML.match(new RegExp('<' + customTag + '[^>]*>'));
      //   const closingTag = `</${customTag}>`
      //   if (openingTag)
      //     return openingTag + sectionHTML.split(openingTag)[1].split(closingTag)[0] + closingTag;
      // }

      function extractCustomElementHTML(sectionHTML, customTag) {
        if (!sectionHTML) return null;
        const openingTag = sectionHTML.match(new RegExp('<' + customTag + '[^>]*>'));
        const closingTag = `</${customTag}>`
        
        if (openingTag)
          return openingTag + sectionHTML.split(openingTag)[1].split(closingTag)[0] + closingTag;
        return null;
      }
      // const announcementBarParent = document.querySelector('#announcement-bar-progress')?.parentElement;
      // if (announcementBarParent) {
      //   const updatedHTML =
      //     extractCustomElementHTML(html['announcement-progress-bar'], 'amsm-announcement-bar');
      //   announcementBarParent.innerHTML = updatedHTML;
      // }

      const microCartParent = document.querySelector('#micro-cart__wrapper')?.parentElement;
      if (microCartParent) {
        const updatedHTML =
          extractCustomElementHTML(html['pack-builder-micro-cart'], 'micro-cart');
        microCartParent.innerHTML = updatedHTML;
      }

      // const MiniCart = document.querySelector('cart-items')?.parentElement;
      //       if (MiniCart) {
      //         const updatedHTML = extractCustomElementHTML(html['drawer__items'], 'cart-items');
      //         MiniCart.innerHTML = updatedHTML;
      //       }

      const cartCountParent = document.querySelector('#cart-count-wrapper');
      if (cartCountParent) {
        const updatedHTML = extractCustomElementHTML(html['header'], 'cart-count');
        cartCountParent.innerHTML = updatedHTML;
      }

     
    }

    document.addEventListener('cartaddsuccess', reRenderAnnouncementBarAndMicroCartAndCartCount)
    document.addEventListener('cartremovesuccess', reRenderAnnouncementBarAndMicroCartAndCartCount)
    document.addEventListener('cartupdatesuccess', reRenderAnnouncementBarAndMicroCartAndCartCount)